import { RadioButton } from '@everlywell/leaves';
import React from 'react';

import { SymptomLevels } from '../';
import * as S from './styles';

export type SymptomQuestionsProps = {
  handleSymptomClick: Function;
  symptomLevel: string;
};

const SymptomQuestions = ({
  handleSymptomClick,
  symptomLevel,
}: SymptomQuestionsProps) => (
  <>
    <S.QuestionCount>Question 1 of 2</S.QuestionCount>
    <S.Question>How would you rate your symptoms right now?</S.Question>
    <S.Fieldset>
      <S.Legend>How would you rate your symptoms?</S.Legend>
      <S.RadioOption
        onClick={() => handleSymptomClick(SymptomLevels.NoSymptoms)}
      >
        <S.RadioOptionHeading>
          <S.OptionTitle>No Symptoms</S.OptionTitle>
          <RadioButton
            id={SymptomLevels.NoSymptoms}
            name={SymptomLevels.NoSymptoms}
            checked={symptomLevel === SymptomLevels.NoSymptoms}
            onChange={() => handleSymptomClick(SymptomLevels.NoSymptoms)}
          />
        </S.RadioOptionHeading>
        <S.RadioOptionContent>
          <S.UL>
            <S.LI>
              I am not having any symptoms, or I am having symptoms that are not
              listed in the other two choices.
            </S.LI>
          </S.UL>
        </S.RadioOptionContent>
      </S.RadioOption>
      <S.RadioOption
        onClick={() => handleSymptomClick(SymptomLevels.MildSymptoms)}
      >
        <S.RadioOptionHeading>
          <S.OptionTitle>Mild Symptoms</S.OptionTitle>
          <RadioButton
            id={SymptomLevels.MildSymptoms}
            name={SymptomLevels.MildSymptoms}
            checked={symptomLevel === SymptomLevels.MildSymptoms}
            onChange={() => handleSymptomClick(SymptomLevels.MildSymptoms)}
          />
        </S.RadioOptionHeading>
        <S.RadioOptionContent>
          <S.UL>
            <S.LI>
              I have a fever between 100.4ºF and 102ºF, am feeling feverish, or
              feel warm to the touch.
            </S.LI>
            <S.LI>
              I am having flu-like symptoms (chills, runny or stuffy nose, whole
              body aches, a headache, and/or feeling tired).
            </S.LI>
            <S.LI>I have a new loss of taste or smell.</S.LI>
            <S.LI>I have a new or worsening cough.</S.LI>
            <S.LI>I have a new or worsening sore throat.</S.LI>
            <S.LI>
              I have shortness of breath that is not limiting my ability to
              speak.
            </S.LI>
          </S.UL>
        </S.RadioOptionContent>
      </S.RadioOption>
      <S.RadioOption
        onClick={() => handleSymptomClick(SymptomLevels.SevereSymptoms)}
      >
        <S.RadioOptionHeading>
          <S.OptionTitle>Severe Symptoms</S.OptionTitle>
          <RadioButton
            id={SymptomLevels.SevereSymptoms}
            name={SymptomLevels.SevereSymptoms}
            onChange={() => handleSymptomClick(SymptomLevels.SevereSymptoms)}
            checked={symptomLevel === SymptomLevels.SevereSymptoms}
          />
        </S.RadioOptionHeading>
        <S.RadioOptionContent>
          <S.UL>
            <S.LI>
              I have a fever of greater than 102ºF, OR I have a high fever
              lasting longer than 48 hours.
            </S.LI>
            <S.LI>
              I can’t speak in full sentences or do simple activities without
              feeling short of breath.
            </S.LI>
            <S.LI>
              I have severe coughing spells, or I am coughing up blood.
            </S.LI>
            <S.LI>My lips or face are blue.</S.LI>
            <S.LI>I have severe and constant pain or pressure in my chest</S.LI>
            <S.LI>I am very tired or lethargic.</S.LI>
            <S.LI>I am dizzy, lightheaded or too weak to stand.</S.LI>
            <S.LI>I am having slurred speech or seizures.</S.LI>
            <S.LI>
              I do not feel like I can stay at home because I feel seriously
              ill.
            </S.LI>
          </S.UL>
        </S.RadioOptionContent>
      </S.RadioOption>
    </S.Fieldset>
  </>
);

export default SymptomQuestions;
